'use client';

import { type CardProps } from '@ironhack/design-system2/components/card';
import { UserCard as DsUserCard } from '@ironhack/design-system2/components/user-card';
import { type ReactElement } from 'react';

import { CmsImage } from '@/app/components/server/cms-image';
import { type DatoUserCardBlock } from '@/lib/datocms';

type Size = 'xs' | 'l' | 'xl' | '2xl' | '3xl';
type Props = {
  card: DatoUserCardBlock;
  size?: Size;
} & Omit<CardProps, 'size'>;

export const UserCard = (props: Props): ReactElement => {
  const {
    card: { image, logos = [], ...card },
    size = 'l',
    ...cardProps
  } = props;

  const logoElements = logos.map(({ responsiveImage }) => (
    <CmsImage data={responsiveImage} key={responsiveImage.src} />
  ));
  return (
    <DsUserCard
      image={<CmsImage data={image.responsiveImage} sizes="160px" />}
      logos={logoElements}
      size={size}
      {...card}
      {...cardProps}
      {...(cardProps.bg !== 'transparent' && { color: 'text.primary' })}
    />
  );
};
